module.exports = __webpack_public_path__ + "static/Castie_Intro-a0f13c5a0fa09ffc4a5e90b90bc0ee9d.png";